<template>
  <div class="stepsInventario">
    <el-steps :active='step'>
      <el-step
        v-for="(s,i) in steps"
        :key="i"
        :title="$t(`Paso ${i+1}`)"
        :description="$t(s)"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'StepsInventario',
  props: [
    'step',
  ],
  computed:{
    role() { return this.$store.getters.role },
    mel() { return this.role.faena_id === '5a6f78337b772dcfe68241d5'},
    steps(){
      return this.mel
        ? ['Selección Riesgos', 'Resumen']
        : ['Selección Riesgos', 'Definición Procedimiento', 'Resumen']
    }
  }
};
</script>

<style scoped>
.stepsInventario {
  margin-top: 20px;
}
</style>
